import _ from 'lodash'
import { getCourseDetail, askSuggestForContinueLearning, askSuggestForLast, scormLaunchURL, scormLaunchURLWithToken,scormPreviewURL, getCourseTopics, getCourseMicroCompetencies, getLearningTopicDetails,
getLearningContentDetails, getScormDetails, askSuggestForNext, getCourseGradeForClass, getMicroCompetencySummary, getMicroCompetencySummaryForSelectedUser,
getCompetencySummary, getCompetencySummaryForSelectedUser, getCourseCompetencies, startLearningActivity, continueLearningActivity, stopLearningActivity, saveRating,
getClassSummaryWithPeer, getEntityCompetencySummary, getChildrenSummary, getEntityActivity, getClassSummary, getCompetencySummaryForClass,
getChildrenCompetencySummaryForClass, getFullClassSummary, saveCourse, autonumber, getCopyCourseDetail, deleteCourse, getPLOs, applyCompetencyTreeToCourse,
getEnrolledObserverUsers, getEnrolledInstructorUsers, getEnrolledCuratorUsers, getEnrolledStudentUsers, enrollUsers, getAllCourses, deleteMultipleCourses,
deleteMultipleCompetencies, isCompetencyExists, uploadCompetency, getBlackboardCourseAccess, getBlackboardContentAccess, getBlackboardAnnouncements,
getBlackboardGradeActivity, getUnloackQuest, doCsvUploadForCourseSection, doClassSummaryExport, getBlackboardAggregatedGradeActivity,addMissingSummaries,
addOrDropStudentFromClassAverage, doExportLTIAssignmentGrade, saveCourseCompetencyCompleted, getMicroCompetencyTopics, getCompetencyTopics, addReleaseLogicForMicroCompetency, addReleaseLogicForMCs, postUploadMicroCompetencyMappingCsvFile, convertToModularCourse, doUnbundleMCFromCourse, doExportCourseConversionToCsv, airMultipleCourses, archiveMultipleCourses, addPrePostCompetency, updateAttemptScoreBySessionId, doDignosticReportExport, getAllDiagnosticTests, getDignosticReportForClass, deleteAttemptBySessionId, purgeCompetencyLogicMessage, fetchCompetencyLogicMessage, updateCompetencyLogicMessage, getMyCourses, getCheckBrokenLinks, doObservationExport, doCourseTreeExport, updateCourseStatusForUser, updateCourseStatusForUsers, getCoursesWithChannel, getKCMessage, getKCDescription,getObservationForClass, getObservationForLearner, getChildrenCompetencySummaryForLearner } from '../api'

export const loadCourseDetail = ({ state, commit }, uuid) => {
  if (_.isEmpty(state.course)) {
    return getCourseDetail(uuid).then((res) => {
      commit('LOAD_COURSE', res)
      return res
    })
  } else {
    commit('LOAD_COURSE', state.course)
    return state.course
  }
}

export const loadCourseDetailFromServer = ({ state, commit }, uuid) => {
  return getCourseDetail(uuid).then((res) => {
    commit('LOAD_COURSE', res)
    return res
  })
}
export const loadCourseInformation = ({ state, commit }, uuid) => {
  return getCourseDetail(uuid).then((res) => {
    return res
  })
}

export const loadCheckBrokenLinks = ({ state, commit }, uuid) => {
  return getCheckBrokenLinks(uuid).then((res) => {
    return res
  })
}
export const loadCourseDetailFromServerWithoutStoringInState = ({ state, commit }, uuid) => {
  return getCourseDetail(uuid).then((res) => {
    return res
  })
}
export const loadCompetencyTopics = ({ state, commit }, {courseId, mcId}) => {
  return getCompetencyTopics(courseId, mcId).then((res) => {
    return res
  })
}
export const loadMicroCompetencyTopics = ({ state, commit }, {courseId, mcId}) => {
  return getMicroCompetencyTopics(courseId, mcId).then((res) => {
    return res
  })
}
export const loadCourseTopics = ({ state, commit }, { uuid, loadDataFromServer }) => {
  var stateTopics = state.topics
  var stateLinearTopics = state.linearTopics
  var stateTopicsMap = state.topicsMap
  if (loadDataFromServer || stateTopics.length === 0 || stateLinearTopics.length === 0) {
    return getCourseTopics(uuid).then((res) => {
      var topics = JSON.parse(res.plan)
//      var linearTopics = [].concat(topics)
      var linearTopics = []
      var topicsMap = {}
      for (var i = 0; i < topics.length; i++) {
        linearTopics = linearTopics.concat(topics[i])
        if (topics[i].plan) {
          topics[i].subtopics = JSON.parse(topics[i].plan)
 //         linearTopics = linearTopics.concat(topics[i].subtopics)
          for (var j = 0; j < topics[i].subtopics.length; j++) {
            linearTopics = linearTopics.concat(topics[i].subtopics[j])
            if (topics[i].subtopics[j].plan) {
              topics[i].subtopics[j].subtopics = JSON.parse(topics[i].subtopics[j].plan)
              linearTopics = linearTopics.concat(topics[i].subtopics[j].subtopics)
            }
          }
        }
      }
      commit('LOAD_COURSE_TOPICS', {isState: false, data: topics})
      commit('LOAD_COURSE_LINEAR_TOPICS', {isState: false, data: linearTopics})

      linearTopics.forEach((item, i) => {
        topicsMap[item.uuid] = item
      })
      commit('LOAD_COURSE_TOPICS_MAP', {isState: false, data: topicsMap})
      return topics
    })
  } else {
    commit('LOAD_COURSE_TOPICS', {isState: true, data: stateTopics})
    commit('LOAD_COURSE_LINEAR_TOPICS', {isState: true, data: stateLinearTopics})
    commit('LOAD_COURSE_TOPICS_MAP', {isState: true, data: stateTopicsMap})
    return stateTopics
  }
}

export const loadMicroCompetencies = ({ state, commit }, uuid) => {
  if (state.microcompetencies.length === 0) {
    return getCourseMicroCompetencies(uuid).then((res) => {
      commit('LOAD_COURSE_MICROCOMPETENCIES', res)
    })
  } else {
    commit('LOAD_COURSE_MICROCOMPETENCIES', state.microcompetencies)
  }
}

export const loadContinueLearning = ({ state, commit }, uuid) => {
  if (_.isEmpty(state.continueLearning)) {
    return askSuggestForContinueLearning(uuid).then((res) => {
      commit('LOAD_CONTINUE_LEARNING', res)
      return res
    })
  } else {
    commit('LOAD_CONTINUE_LEARNING', state.continueLearning)
    return state.continueLearning
  }
}

export const loadContinueLearningLast = ({ state, commit }, { uuid, loadDataFromServer }) => {
  if (state.continueLearningLast.length === 0 || loadDataFromServer) {
    return askSuggestForLast(uuid).then((res) => {
      commit('LOAD_CONTINUE_LEARNING_LAST', res)
      return res
    })
  } else {
    commit('LOAD_CONTINUE_LEARNING_LAST', state.continueLearningLast)
    return state.continueLearningLast
  }
}
export const loadTopicDetail = ({ state, commit }, topicId ) => {
    return getLearningTopicDetails(topicId).then((res) => {
        return res
    })
}
export const saveCompetencyLogicMessage = ({ state, commit },obj ) => {
    return updateCompetencyLogicMessage(obj).then((res) => {
        return res
    })
}
export const getCompetencyLogicMessage = ({ state, commit },{ courseId, topicId, type } ) => {
    return fetchCompetencyLogicMessage(courseId, topicId, type).then((res) => {
        return res
    })
}
export const loadAddPrePostCompetency = ({ state, commit },{ courseId, position, data } ) => {
    return addPrePostCompetency(courseId, position, data).then((res) => {
        return res
    })
}
export const addReleaseLogic = ({ state, commit },{ courseId, type, unlockDate } ) => {
    return addReleaseLogicForMCs(courseId, type, unlockDate).then((res) => {
        return res
    })
}
export const addReleaseLogicForMC = ({ state, commit },{ courseId, mcId, type, depndesOn } ) => {
    return addReleaseLogicForMicroCompetency(courseId, mcId, type, depndesOn).then((res) => {
        return res
    })
}
export const deleteCompetencyLogicMessage = ({ state, commit },id ) => {
    return purgeCompetencyLogicMessage(id).then((res) => {
        return res
    })
}
export const loadEntityDetail = ({ state, commit }, { entityType, entityUuid }) => {
  if (entityType === 'LearningTopic') {
    return getLearningTopicDetails(entityUuid).then((res) => {
      commit('LOAD_ENTITY_DETAIL', res)
      commit('LOAD_ENTITY_UUID', entityUuid)
    })
  } else {
    return getLearningContentDetails(entityUuid).then((res) => {
      commit('LOAD_ENTITY_DETAIL', res)
      commit('LOAD_ENTITY_UUID', entityUuid)
      return res
    })
  }
}

export const loadAIResource = ({ state, commit }, { entityType, entityUuid }) => {
    return getLearningContentDetails(entityUuid).then((res) => {
      return res
    })
}

export const loadScormDetail = ({ state, commit }, { entityUuid,token }) => {
    return getScormDetails(entityUuid, token).then((res) => {
      return res
    })
}


export const loadEntityActivity = ({ state, commit }, { courseUuid, entityType, entityUuid }) => {
  return getEntityActivity(courseUuid, entityUuid).then((res) => {
    commit('LOAD_ENTITY_ACTIVITY', res)
    return res
  })
}

export const loadNextEntityDetail = ({ state, commit }, { courseUuid, entityType, entityUuid }) => {
  return askSuggestForNext(courseUuid, entityUuid).then((res) => {
    commit('LOAD_NEXT_ENTITY_DETAIL', res)
    commit('LOAD_ENTITY_UUID', res.uuid)
    return res
  })
}

export const loadClassGrade = ({ state, commit }, courseId) => {
  return getCourseGradeForClass(courseId).then((res) => {
    commit('LOAD_CLASS_GRADE', res)
  })
}

export const loadMicroCompetencyProgress = ({ state, commit }, { entityId, loadDataFromServer }) => {
  if (_.isEmpty(state.mcSummary) || loadDataFromServer) {
    return getMicroCompetencySummary(entityId).then((res) => {
      commit('LOAD_MICRO_COMPETENCY_SUMMARY', res)
      return res
    })
  } else {
    commit('LOAD_MICRO_COMPETENCY_SUMMARY', state.mcSummary)
    return state.mcSummary
  }
}

export const loadMicroCompetencyProgressForSelectedUser = ({ state, commit }, { entityId, userId }) => {
  return getMicroCompetencySummaryForSelectedUser(entityId, userId).then((res) => {
    commit('LOAD_MICRO_COMPETENCY_SUMMARY_FOR_SELECTED_USER', res)
    return res
  })
}

export const loadCompetencyProgress = ({ state, commit }, { entityId, loadDataFromServer }) => {
  if (_.isEmpty(state.competencySummary) || loadDataFromServer) {
    return getCompetencySummary(entityId).then((res) => {
      commit('LOAD_COURSE_COMPETENCIES', res)
      if (res && res.length > 0) {
        for (var i = 0; i < res.length; i++) {
          var competency = res[i]
          if (competency && (competency.entityId === entityId)) {
            commit('LOAD_COMPETENCY_SUMMARY', competency)
            return competency
          }
        }
      }
    })
  } else {
    commit('LOAD_COMPETENCY_SUMMARY', state.competencySummary)
    return state.competencySummary
  }
}

export const loadCompetencyProgressForSelectedUser = ({ state, commit }, { entityId, userId }) => {
  return getCompetencySummaryForSelectedUser(entityId, userId).then((res) => {
    if (res && res.length > 0) {
      for (var i = 0; i < res.length; i++) {
        var competency = res[i]
        if (competency && (competency.entityId === entityId)) {
          commit('LOAD_COMPETENCY_SUMMARY_FOR_SELECTED_USER', competency)
          return competency
        }
      }
    }
  })
}

export const loadCompetencyProgressForCourseAndUser = ({ state, commit }, entityId) => {
  return getCompetencySummary(entityId).then((res) => {
    if (res && res.length > 0) {
      for (var i = 0; i < res.length; i++) {
        var competency = res[i]
        if (competency && (competency.entityId === entityId)) {
          return competency
        }
      }
    }
  })
}

export const loadCourseCompetencies = ({ state, commit }, { courseId, loadDataFromServer }) => {
  if (loadDataFromServer || (state.competencies.length === 0)) {
    return getCourseCompetencies(courseId).then((res) => {
      commit('LOAD_COURSE_COMPETENCIES', res)
      return res
    })
  } else {
    commit('LOAD_COURSE_COMPETENCIES', state.competencies)
    return state.competencies
  }
}

export const updateIsTocOpen = ({ state, commit }, isTocOpen) => {
  commit('LOAD_IS_TOC_OPEN', isTocOpen)
}

export const startActivity = ({ state, commit }, activity) => {
  return startLearningActivity(activity)
}

export const continueActivity = ({ state, commit }, activity) => {
  return continueLearningActivity(activity)
}

export const stopActivity = ({ state, commit }, activity) => {
  return stopLearningActivity(activity)
}

export const storeRating = ({ state, commit }, ratingInfo) => {
  return saveRating(ratingInfo)
}

export const loadEntityCompetency = ({ state, commit }, { courseId, entityId }) => {
  return getEntityCompetencySummary(courseId, entityId).then((res) => {
    commit('LOAD_ENTITY_COMPETENCY', res)
  })
}

export const loadClassSummary = ({ state, commit }, courseId) => {
  if (_.isEmpty(state.classSummary)) {
    return getClassSummary(courseId).then((res) => {
      commit('LOAD_CLASS_SUMMARY', res)
      return res
    })
  } else {
    commit('LOAD_CLASS_SUMMARY', state.classSummary)
    return state.classSummary
  }
}

export const loadFullClassSummary = ({ state, commit }, { courseId, loadDataFromServer }) => {
  if (state.fullClassSummary.length === 0 || loadDataFromServer) {
    return getFullClassSummary(courseId).then((res) => {
      commit('LOAD_FULL_CLASS_SUMMARY', res)
      return res
    })
  } else {
    commit('LOAD_FULL_CLASS_SUMMARY', state.fullClassSummary)
    return state.fullClassSummary
  }
}

export const loadClassSummaryWithPeer = ({ state, commit }, {entityId, userId}) => {
  return getClassSummaryWithPeer(entityId, userId).then((res) => {
    commit('LOAD_CLASS_SUMMARY_WITH_PEER', res)
    return res
  })
}

export const loadChildrenSummary = ({ state, commit }, { courseId, competencyId, userId }) => {
  return getChildrenSummary(courseId, competencyId, userId).then((res) => {
    commit('LOAD_CHILDREN_SUMMARY', res)
    return res
  })
}

export const loadCompetencySummaryForClass = ({ state, commit }, courseId) => {
  return getCompetencySummaryForClass(courseId).then((res) => {
    commit('LOAD_COMPETENCY_SUMMARY_FOR_CLASS', res)
    return res
  })
}

export const loadChildrenCompetencySummaryForClass = ({ state, commit }, { courseId, competencyId }) => {
  return getChildrenCompetencySummaryForClass(courseId, competencyId).then((res) => {
    commit('LOAD_CHILDREN_COMPETENCY_SUMMARY_FOR_CLASS', res)
    return res
  })
}

export const loadChildrenCompetencySummaryForLearner = ({ state, commit }, { courseId, competencyId }) => {
  return getChildrenCompetencySummaryForLearner(courseId, competencyId).then((res) => {
    return res
  })
}

export const loadObservationForClass = ({ state, commit }, { courseId, competencyId,allCourses }) => {
  return getObservationForClass(courseId, competencyId,allCourses).then((res) => {
    return res
  })
}
export const loadDignosticReportForClass = ({ state, commit }, { courseId, assessmentId}) => {
  return getDignosticReportForClass(courseId, assessmentId).then((res) => {
    return res
  })
}
export const loadAllDiagnosticTests = ({ state, commit }, courseId) => {
  return getAllDiagnosticTests(courseId).then((res) => {
    return res
  })
}
export const loadObservationForLearner = ({ state, commit }, { courseId }) => {
  return getObservationForLearner(courseId).then((res) => {
    return res
  })
}
export const markCourseCompetencyCompleted = ({ state, commit }, { courseId, userId }) => {
  return saveCourseCompetencyCompleted(courseId, userId ).then((res) => {
    return res
  })
}
export const saveCourseDetail = ({ state, commit }, data) => {
  return saveCourse(data).then((res) => {
    commit('LOAD_COURSE', res)
    return res
  })
}

export const autonumberContent = ({ state, commit }, data) => {
  return autonumber(data).then((res) => {
    commit('LOAD_COURSE', res)
    return res
  })
}

export const loadCopyCourseDetail = ({ state, commit }, uuid) => {
  return getCopyCourseDetail(uuid).then((res) => {
    return res
  })
}
export const getScormLaunchURL = ({ state, commit }, entity) => {
  return scormLaunchURL(entity).then((res) => {
    return res
  })
}
export const getScormLaunchURLWithToken = ({ state, commit }, entity) => {
  return scormLaunchURLWithToken(entity).then((res) => {
    return res
  })
}

export const getScormPreviewURL = ({ state, commit }, entity) => {
  return scormPreviewURL(entity).then((res) => {
    return res
  })
}


export const deleteCourseDetail = ({ state, commit }, uuid) => {
  return deleteCourse(uuid).then((res) => {
    return res
  })
}

export const loadPLOForInstitution = ({ state, commit }) => {
  return getPLOs().then((res) => {
    return res
  })
}

export const addCompetencyTreeToCourse = ({ state, commit }, { courseId, competencyId, version}) => {
  return applyCompetencyTreeToCourse(courseId, competencyId, version).then((res) => {
    return res
  })
}

export const loadEnrolledStudentUsers = ({ state, commit }, parentSpaceId) => {
  return getEnrolledStudentUsers(parentSpaceId)
}

export const loadEnrolledCuratorUsers = ({ state, commit }, parentSpaceId) => {
  return getEnrolledCuratorUsers(parentSpaceId)
}

export const loadEnrolledInstructorUsers = ({ state, commit }, parentSpaceId) => {
  return getEnrolledInstructorUsers(parentSpaceId)
}

export const loadEnrolledObserverUsers = ({ state, commit }, parentSpaceId) => {
  return getEnrolledObserverUsers(parentSpaceId)
}

export const loadEnrollUsers = ({ state, commit }, data) => {
  return enrollUsers(data)
}

export const loadAllCourses = ({ state, commit }, { page, count, title, archive, itemReport, version, masterCourseId }) => {
  return getAllCourses(page, count, title, archive, itemReport, version, masterCourseId)
}
export const loadAllMyCourses = ({ state, commit }, { page, count, title }) => {
  return getMyCourses(page, count, title)
}

export const deleteCourses = ({ state, commit }, itemsToDelete) => {
  return deleteMultipleCourses(itemsToDelete)
}
export const archiveCourses = ({ state, commit }, {itemsToArchive, flag}) => {
  return archiveMultipleCourses(itemsToArchive, flag)
}
export const airCourses = ({ state, commit }, {itemsToAir, flag}) => {
  return airMultipleCourses(itemsToAir, flag)
}
export const deleteCompetencies = ({ state, commit }, uuids) => {
  return deleteMultipleCompetencies(uuids)
}

export const checkCompetency = ({ state, commit }, code) => {
  return isCompetencyExists(code)
}

export const uploadCompetencyTree = ({ state, commit }, { data, success, error }) => {
  uploadCompetency(data, success, error)
}

export const loadBlackboardCourseAccess = ({ state, commit }, lmsCourseId) => {
  return getBlackboardCourseAccess(lmsCourseId).then((res) => {
    commit('LOAD_BLACKBOARD_COURSE_ACCESS', res)
    return res
  })
}

export const loadBlackboardContentAccess = ({ state, commit }, lmsCourseId) => {
  return getBlackboardContentAccess(lmsCourseId).then((res) => {
    commit('LOAD_BLACKBOARD_CONTENT_ACCESS', res)
    return res
  })
}

export const loadBlackboardGradeActivity = ({ state, commit }, lmsCourseId) => {
  return getBlackboardGradeActivity(lmsCourseId).then((res) => {
    commit('LOAD_BLACKBOARD_GRADE_ACTIVITY', res)
    return res
  })
}

export const loadBlackboardAggregatedGradeActivity = ({ state, commit }, lmsCourseId) => {
  return getBlackboardAggregatedGradeActivity(lmsCourseId).then((res) => {
    commit('LOAD_BLACKBOARD_AGGREGATED_GRADE_ACTIVITY', res.aggregatedGradeActivities)
    return res
  })
}

export const loadBlackboardAnnouncements = ({ state, commit }, lmsCourseId) => {
  return getBlackboardAnnouncements(lmsCourseId).then((res) => {
    commit('LOAD_BLACKBOARD_ANNOUNCEMENTS', res)
    return res
  })
}

export const loadUnlockQuest = ({ state, commit }, {userId, courseId, contentId}) => {
  return getUnloackQuest(userId, courseId, contentId).then((res) => {
    return res
  })
}
export const deleteAttempt = ({ state, commit }, sessionId) => {
  return deleteAttemptBySessionId(sessionId).then((res) => {
    return res
  })
}
export const updateAttemptScore = ({ state, commit }, {sessionId, newScore}) => {
  return updateAttemptScoreBySessionId(sessionId, newScore).then((res) => {
    return res
  })
}

export const uploadCourseSectionCsvFile = ({ state, commit }, {institutionId, userId, fileData}) => {
  return doCsvUploadForCourseSection(institutionId, userId, fileData).then(res => {
    return res
  })
}

export const exportClassSummaryToCsv = ({ state, commit }, {courseId, competencyId}) => {
  return doClassSummaryExport(courseId, competencyId).then(res => {
    return res
  })
}
export const fixMissingSummaries = ({ state, commit }, courseId) => {
  return addMissingSummaries(courseId).then(res => {
    return res
  })
}

export const exportObservationoToCsv = ({ state, commit }, {courseId, competencyId, allCourses, status}) => {
  return doObservationExport(courseId, competencyId, allCourses, status).then(res => {
    return res
  })
}
export const exportDignosticReportToCsv = ({ state, commit }, {courseId, assessmentId}) => {
  return doDignosticReportExport(courseId, assessmentId).then(res => {
    return res
  })
}
export const exportCourseTreeToCsv = ({ state, commit }, courseId) => {
  return doCourseTreeExport(courseId).then(res => {
    return res
  })
}
export const exportCourseConversionToCsv = ({ state, commit }, courseId) => {
  return doExportCourseConversionToCsv(courseId).then(res => {
    return res
  })
}
export const unbundleMCFromCourse = ({ state, commit }, {courseId,subject,moduleName}) => {
  return doUnbundleMCFromCourse(courseId,subject,moduleName).then(res => {
    return res
  })
}
export const exportLTIAssignmentGrade = ({ state, commit }, courseId) => {
  return doExportLTIAssignmentGrade(courseId).then(res => {
    return res
  })
}
export const convertCourseToModular = ({ state, commit }, {courseId,subject,moduleName}) => {
  return convertToModularCourse(courseId,subject,moduleName).then(res => {
    return res
  })
}

export const loadAddOrDropStudentFromClassAverage = ({ state, commit }, {courseId, userId, action}) => {
  return addOrDropStudentFromClassAverage(courseId, userId, action)
}

export const loadCourseStatusUpdateForUser = ({ state, commit }, {courseId, userId, status}) => {
  return updateCourseStatusForUser(courseId, userId, status)
}

export const loadCourseStatusUpdateForUsers = ({ state, commit }, {courseId, data}) => {
  return updateCourseStatusForUsers(courseId, data)
}

export const loadCoursesWithChannel = ({ state, commit }) => {
  return getCoursesWithChannel()
}

export const loadKCMessage = ({ state, commit }, { entityId, courseType }) => {
  return getKCMessage(entityId, courseType)
}

export const loadKCDescription = ({ state, commit }, { entityId, courseType, courseId }) => {
  return getKCDescription(entityId, courseType, courseId)
}

export const uploadMicroCompetencyMappingCsvFile = ({ state, commit }, {fileData}) => {
  return postUploadMicroCompetencyMappingCsvFile(fileData).then(res => {
    return res
  })
}




// WEBPACK FOOTER //
// ./src/app/course/vuex/actions.js